import * as Sentry from '@sentry/react'
import type { AppType } from 'edge/src/index'
import { hc } from 'hono/client'

import { config } from '~/config/env'
import { LS_JWT_KEY } from '~/const/api'

const baseUrl = config.VITE_NGROK_URL ? `${config.VITE_NGROK_URL}/edge` : config.VITE_EDGE_BASE

// TODO: find a way to use middleware to intercept 403 responses in UserProvider
export const edgeClient = hc<AppType>(baseUrl, {
  headers: () => {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${localStorage.getItem(LS_JWT_KEY)}`,
    }
    // CF Workers OTEL does not yet link inbound W3C context, but this keeps Sentry SPA
    // spans consistent with apiClient and is ready when CF adds propagation.
    const traceData = Sentry.getTraceData({ propagateTraceparent: true })
    for (const [key, value] of Object.entries(traceData)) if (value) headers[key] = value

    return headers
  },
})
